import { render } from "./goods-item.vue?vue&type=template&id=34ab862a&scoped=true"
import script from "./goods-item.vue?vue&type=script&lang=js"
export * from "./goods-item.vue?vue&type=script&lang=js"

import "./goods-item.vue?vue&type=style&index=0&id=34ab862a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ab862a"]])

export default __exports__